<template>
    <div class="view-container">
        <div class="header">
            <div class="login-box">
                <!--                <div class="title">-->
<!--                    <div>-->
<!--                        <span style="color: #F23B2F;font-weight: bold;">1</span>-->
<!--                        <span style="color: #2C95FF;font-weight: bold;">+</span>-->
<!--                        <span style="color: #F23B2F;font-weight: bold;">X</span>-->
<!--                    </div>-->
<!--                    电子商务客户服务平台-->
<!--                </div>-->
                <div class="title">
                    <img src="../../assets/images/layout_title.png" alt="">
                </div>
                <div class="router">
                    <router-link :to="levelOne.path" class="levelOne"
                                 :class="{current: levelOne.name === $route.name || $route.meta.parentName && $route.meta.parentName.includes(levelOne.name)}"
                                 v-for="levelOne in teacherMenu" :key="levelOne.name">
                        <span class="one-text">{{levelOne.meta.title}}</span>
                        <span class="one-icon"></span>
                    </router-link>
                </div>
                <div class="user-info">
                    <div class="user-avatar">
                        <img :src="userAvatar ? userAvatar : require('../../assets/images/user_img.png')" alt="">
                    </div>
                    <div class="user-name">{{userName}}</div>
                    <i @click="logoutBtn" class="iconfont logout-btn">&#xe60c;</i>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="main-container">
                <div class="content">
                    <router-view/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {userLogout} from '@/utils/apis'
    import {mapState} from 'vuex'

    export default {
        name: "TeacherDataCenterLayout",
        data() {
            return {
                activeIndex: '/dataCenter/detail/index',
                userName: '',
                userAvatar: '',
                role: '',
                levelTwoMenu: [],
                showTab:true,
            }
        },
        computed: mapState({
            teacherMenu: state => state.teacherMenu[0].children,
        }),
        mounted() {
            this.role = localStorage.getItem('role');
            if (this.role === '3') {
                this.userName = localStorage.getItem('teacherName');
                this.userAvatar = localStorage.getItem('teacherAvatar');
            }

            let active = localStorage.getItem('teacherActive');
            let routeName = this.$route.name;
            if (routeName !== 'teachingCenterGoodsInfo' && active !== undefined && active !== null) {
                this.activeIndex = active
            }
            this.getLevelTwoMenu(this.$route)
        },
        methods: {
            // 获取二级菜单
            getLevelTwoMenu(route) {
                if(route.meta.level && route.meta.level === 2){
                    this.showTab = false
                } else {
                    this.showTab = true
                }
                const twoArr = this.teacherMenu.find(item => {
                    if (route.meta.parentName) {
                        return route.meta.parentName[0] === item.name
                    } else {
                        return item.name === route.name
                    }
                })
                if (twoArr.children) {
                    this.levelTwoMenu = twoArr.children.filter(item => !item.meta.hidden)
                } else {
                    this.levelTwoMenu = []
                }
            },
            // 退出
            logoutBtn() {
                userLogout().then((res) => {
                    localStorage.clear();
                    this.$router.push('/');
                    this.$message.success(res.msg);
                }).catch((err) => {
                    console.log(err);
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .view-container {
        width: 100vw;
        height: 100vh;
        min-width: 1200px;
        background: #F7F8FC;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .header {
            width: 100%;
            height: 60px;
            background: #fff;
            box-shadow: 0 2px 5px 0 rgba(15, 26, 54, 0.05);
            display: flex;
            z-index: 9;

            .login-box {
                width: 100%;
                font-size: 16px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 20px;
                .title {
                    display: flex;
                    font-size: 20px;
                    font-weight: 400;
                    color: #333;
                }
                .user-info {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    .user-avatar {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 40px;
                        height: 40px;
                        margin-right: 10px;
                        img {
                            max-width: 100%;
                            max-height: 100%;
                            border-radius: 50%;
                        }
                    }

                    .user-name {
                        width: 100px;
                        max-height: 50px;
                        text-align: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        color: #333;
                    }

                    .logout-btn {
                        cursor: pointer;
                        margin-left: 20px;
                        color: #F23B2F;
                    }
                }
                .router {
                    position: relative;
                    height: 60px;
                    flex: 1;
                    width: 1%;
                    margin: 0 20px;
                    .one-text {
                        display: inline-block;
                        text-align: center;
                        width: 104px;
                    }
                    .levelOne {
                        position: absolute;
                        display: inline-block;
                        width: 104px;
                        height: 60px;
                        line-height: 60px;
                        color: #333;
                        padding: 0 20px;
                        transition: all .3s;
                        .one-icon {
                            width: 104px;
                            height: 4px;
                            background-color: transparent;
                            top: 54px;
                        }
                        &:nth-child(2) {
                            left: 144px;
                        }
                        &:nth-child(3) {
                            left: 288px;
                        }
                        &:nth-child(4) {
                            left: 432px;
                        }
                        &:nth-child(5) {
                            left: 576px;
                        }
                        &:nth-child(6) {
                            left: 720px;
                        }
                        &.current {
                            height: 60px;
                            color: #F23B2F;
                            border-radius: 4px 4px 0 0;
                            span {
                                position: absolute;
                            }
                            .one-icon {
                                width: 104px;
                                height: 4px;
                                background-color: #F23B2F;
                                top: 57px;
                            }
                        }
                    }
                }
            }
        }

        .main {
            width: 100%;
            height: 1%;
            flex: 1;
            display: flex;
            .menu-box {
                width: 210px;
                height: 100%;
                margin-right: 20px;
                background-color: #fff;
            }
            .levelOne-box {
                width: 100%;
                height: 100%;
                padding-top: 20px;
                display: flex;
                flex-direction: column;
                ::v-deep .el-scrollbar__wrap {
                    overflow-x: hidden;
                }
                .levelTwo {
                    position: relative;
                    height: 60px;
                    padding: 0 10px 0 30px;
                    display: flex;
                    align-items: center;
                    color: #666;
                    line-height: 1;
                    transition: all .3s;
                    .two-text {
                        font-size: 14px;
                        font-weight: 500;
                        margin-left: 10px;
                    }
                    .icon {
                        display: inline-block;
                        width: 5px;
                        height: 60px;
                        background: transparent;
                        position: relative;
                        z-index: 999;
                        left: -30px;
                    }
                    &:hover {
                        color: #F23B2F;
                    }
                    &.current {
                        color: #F23B2F;
                        background: #E7F6EF;
                        .icon {
                            background: #F23B2F;
                        }
                    }
                }
            }
            .main-container {
                display: flex;
                flex: 1;
                flex-direction: column;
                width: 1%;
                margin: 20px;
                .content {
                    flex: 1;
                    height: 1%;
                    position: relative;
                }
            }
        }
    }
</style>